import { GraphQLClient } from 'graphql-request';

/*
 * The endpoint is written as a path so the dev server can proxy it and the
 * browser stays on one origin — but graphql-request calls `new URL(endpoint)`
 * with no base, and `new URL('/graphql')` throws. Every request would fail
 * before reaching the network: `me` throws on page load so nobody is ever
 * signed in, and signing in reports "could not reach the server" while the
 * server is perfectly reachable.
 *
 * Resolving against the current origin keeps it same-origin — the URL is
 * absolute, not cross-site — and `new URL` ignores the base when the first
 * argument is already absolute, so a fully-qualified VITE_GRAPHQL_ENDPOINT
 * still works untouched.
 */
const endpoint = import.meta.env.VITE_GRAPHQL_ENDPOINT ?? '/graphql';

export const gqlClient = new GraphQLClient(new URL(endpoint, window.location.origin).href, {
  // The session is an httpOnly cookie: without this the browser sends nothing,
  // the API sees an anonymous caller, and `me` answers null forever.
  credentials: 'include',
});
